export interface IStorageResponse {
  Data: any;
  Success: boolean;
  Message: string;
  DocumentSaSUri: string;
  Status: string;
  Information: string;
}
export interface IStorageData {
  FileSaSUri: string;
  FileName: string;
}

export interface IFileSasResponse extends IStorageResponse {
  Data: IStorageData;
}

export interface IFileBase {
  CdnStorage: CdnType;
  Container: string;
  Folder: string;
}

export interface IFileUploadUrlRequest extends IFileBase {
  FileNames: string;
  ExcludeFileExistsCheck: boolean;
}

export enum CdnType {
  Cdn,
  ScormCdn,
}
